export const COMPANY = {
  name: "Subhankara Design & Construction Pvt. Ltd.",
  short: "SUBHANKARA",
  tagline: "Design & Construction",
  city: "Patna, Bihar",
  address: "263, Nehru Nagar, Patliputra Colony, Patna, Bihar — 800013",
  phone: "+91 63603 91484",
  phoneRaw: "+916360391484",
  founderPhone: "+91 80840 69261",
  email: "sarthaksingh50@gmail.com",
  hours: "10:00 AM — 6:00 PM",
  closed: "Closed on Thursdays",
  established: "October 2020",
};

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1721244654394-36a7bc2da288?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmFsJTIwYnVpbGRpbmclMjBibHVlcHJpbnQlMjBkZXNpZ258ZW58MHx8fHwxNzg2MDg2NTI4fDA&ixlib=rb-4.1.0&q=85";

export const MARQUEE_ITEMS = [
  "Interior Consulting",
  "Civil & Structural Design",
  "Project Management",
  "Govt. Estimation Services",
  "Turnkey Construction",
  "Approval Drawings",
  "BOQ & Rate Analysis",
];

export const SERVICES = [
  {
    id: "interior",
    index: "01",
    title: "Interior Consultant",
    blurb:
      "Complete interior design consulting — from concept and layout redesign to material palettes and turnkey execution for homes and commercial spaces.",
    types: ["Layout Redesign", "3D Visualisation", "Material & Finish Selection", "Turnkey Interior Execution"],
    cost: "₹1,700 – ₹3,500 / sq.ft turnkey",
    costNote: "Design-only consultation from ₹25,000 up to 10% of project cost + visitation cost",
    justification:
      "Rates move with finish grade — modular vs. bespoke furniture, laminate vs. veneer, standard vs. imported fittings.",
  },
  {
    id: "building",
    index: "02",
    title: "Building & Civil Structure Consultant",
    blurb:
      "Architectural planning, approval drawings and structural design for residential, commercial and institutional buildings — pile foundations to finishing schedules.",
    types: ["Approval & Sanction Drawings", "Structural Design (RCC / Steel)", "Foundation & Pile Design", "Area, Parking & Services Calculations"],
    cost: "From ₹25,000 per design package",
    costNote: "Or up to 10% of project cost for full design-to-approval scope + visitation cost",
    justification:
      "Priced by built-up area, structural complexity and number of sanction iterations required by local authorities.",
  },
  {
    id: "pmc",
    index: "03",
    title: "Project Management",
    blurb:
      "End-to-end EPC / PMC delivery — contracts, tenders, scheduling on Primavera P6, cost control and subcontractor governance, to international documentation standards.",
    types: ["EPC Turnkey Delivery", "PMC & Site Supervision", "Contracts & Commercial Management", "Planning, Scheduling & Cost Control"],
    cost: "₹1,700 – ₹3,500 / sq.ft turnkey EPC",
    costNote: "PMC engagement billed as a % of project cost, scoped per package",
    justification:
      "Turnkey rates carry material, labour and market variables — quoted as base rate + taxes ± variables, locked in a transparent BOQ.",
  },
  {
    id: "govt",
    index: "04",
    title: "Government Projects",
    blurb:
      "Estimation and designing services for all civil and structural government work — SOR-based detailed estimates, BOQs, tender documentation and institutional campus design.",
    types: ["SOR-Based Detailed Estimates", "BOQ & Rate Analysis", "Tender Documentation", "Institutional Design (Schools / Colleges)"],
    cost: "Per-estimate & % of project cost",
    costNote: "Scoped against current SOR schedules with carriage-of-material analysis",
    justification:
      "Government estimates follow official Schedule of Rates — our fee reflects measurement accuracy, revision cycles and tender compliance.",
  },
];

export const INTERIOR_STYLES = [
  {
    id: "minimal",
    label: "Modern Minimal",
    range: "₹1,700 – ₹2,100 / sq.ft",
    image: "/projects/interior-3.jpg",
    description:
      "Clean lines, neutral palettes and modular furniture. Standard-grade laminates, vitrified flooring and efficient storage keep costs lean without feeling bare.",
    includes: ["Modular kitchen & wardrobes", "Vitrified tile flooring", "Standard false ceiling", "Essential lighting plan"],
  },
  {
    id: "contemporary",
    label: "Contemporary",
    range: "₹2,100 – ₹2,600 / sq.ft",
    image: "/projects/interior-4.jpg",
    description:
      "Feature walls, designer lighting and premium laminates. A step up in finish quality with curated textures and open-plan living concepts.",
    includes: ["Designer light fixtures", "Premium laminate / membrane finishes", "Feature wall treatments", "Upgraded hardware & fittings"],
  },
  {
    id: "classic",
    label: "Classic Traditional",
    range: "₹2,400 – ₹3,000 / sq.ft",
    image: "/projects/interior-5.jpg",
    description:
      "Rich woodwork, natural veneer, mouldings and warm layered lighting. Craft-intensive detailing that takes more skilled labour hours per square foot.",
    includes: ["Natural veneer & solid wood", "Decorative mouldings & panelling", "Layered warm lighting", "Custom mandir / display units"],
  },
  {
    id: "luxury",
    label: "Luxury Bespoke",
    range: "₹2,800 – ₹3,500 / sq.ft",
    image: "/projects/interior-6.jpg",
    description:
      "Imported finishes, fully custom furniture, stone surfaces and home automation. Every element is designed once, for one home — yours.",
    includes: ["Imported marble / stone surfaces", "Fully bespoke furniture", "Home automation ready", "Premium sanitary & kitchen brands"],
  },
];

export const PROJECT_TYPES = [
  { id: "all", label: "All Types" },
  { id: "interior", label: "Interior Projects" },
  { id: "design", label: "Design Consultation" },
  { id: "building", label: "Building & Civil" },
  { id: "govt", label: "Govt & Institutional" },
];

export const PROJECT_SEGMENTS = [
  { id: "all", label: "All" },
  { id: "residential", label: "Residential" },
  { id: "commercial", label: "Commercial" },
];

export const PROJECTS = [
  {
    id: "p1",
    category: "interior",
    segment: "residential",
    span: "md:col-span-8",
    image: "/projects/interior-1.jpg",
    title: "Residential Interior & Layout Redesign",
    meta: "10th Floor Apartment · Patna",
    tag: "INTERIOR",
  },
  {
    id: "p2",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/interior-6.jpg",
    title: "Dining & Open Kitchen Concept",
    meta: "Material Palette & 3D Views",
    tag: "INTERIOR",
  },
  {
    id: "p3",
    category: "design",
    segment: "residential",
    span: "md:col-span-6",
    image: "/projects/building-1.jpg",
    title: "G+8 Residential Apartment",
    meta: "Approval Drawings · Pile Foundation · Patna",
    tag: "DESIGN",
  },
  {
    id: "p4",
    category: "design",
    segment: "commercial",
    span: "md:col-span-6",
    image: "/projects/college-1.jpg",
    title: "Pre-University College Master Plan",
    meta: "Infrastructure Development · Bettiah, Bihar",
    tag: "DESIGN",
  },
  {
    id: "p5",
    category: "govt",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/estimate-1.jpg",
    title: "Detailed SOR Estimate",
    meta: "PU College Building · BOQ & Rate Analysis",
    tag: "ESTIMATION",
  },
  {
    id: "p6",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/interior-4.jpg",
    title: "Original vs. Proposed Layout",
    meta: "Space Planning Study",
    tag: "INTERIOR",
  },
  {
    id: "p7",
    category: "building",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/estimate-2.jpg",
    title: "Structural Quantities & Carriage",
    meta: "Civil · PH · Electrical · Tubewell",
    tag: "BUILDING & CIVIL",
  },
  {
    id: "p8",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/basanti-flat-master.jpg",
    title: "Master Bedroom — Basanti Kunj",
    meta: "1st Floor, Flat 5 · Patna",
    tag: "INTERIOR",
  },
  {
    id: "p9",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/basanti-flat-kids.jpg",
    title: "Kids' Room, Sky Theme — Basanti Kunj",
    meta: "1st Floor, Flat 5 · Patna",
    tag: "INTERIOR",
  },
  {
    id: "p11",
    category: "interior",
    segment: "residential",
    span: "md:col-span-8",
    image: "/projects/basanti-101-drawing-dining.jpg",
    title: "Drawing & Dining — Basanti Kunj 101",
    meta: "1st Floor, Flat 101 · Boring Road, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p12",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/basanti-101-bedroom.jpg",
    title: "Bedroom 1 — Basanti Kunj 101",
    meta: "1st Floor, Flat 101 · Boring Road, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p13",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/basanti-101-kitchen.jpg",
    title: "Modular Kitchen — Basanti Kunj 101",
    meta: "1st Floor, Flat 101 · Boring Road, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p14",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/basanti-101-living.jpg",
    title: "Living Room — Basanti Kunj 101",
    meta: "1st Floor, Flat 101 · Boring Road, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p15",
    category: "interior",
    segment: "residential",
    span: "md:col-span-8",
    image: "/projects/bhawani-11a-dining.jpg",
    title: "Dining Room — Bhawani Enclave 11A",
    meta: "Flat 11 A · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p16",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/bhawani-11a-kids.jpg",
    title: "Kids' Room, Starry Ceiling — Bhawani Enclave",
    meta: "Flat 11 A · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p17",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/bhawani-11a-kitchen.jpg",
    title: "Modular Kitchen — Bhawani Enclave",
    meta: "Flat 11 A · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p18",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/bhawani-11a-living.jpg",
    title: "Backlit Mountain Wall — Bhawani Enclave",
    meta: "Flat 11 A · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p19",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/bhawani-11a-tv-lounge.jpg",
    title: "TV Lounge — Bhawani Enclave",
    meta: "Flat 11 A · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p20",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/bhawani-11a-living-2.jpg",
    title: "Family Lounge — Bhawani Enclave",
    meta: "Flat 11 A · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p21",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/bhawani-11a-mandir.jpg",
    title: "Mandir, Lotus Wall — Bhawani Enclave",
    meta: "Flat 11 A · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p22",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/bhawani-11a-master.jpg",
    title: "Master Bedroom, Backlit Headboard — Bhawani Enclave",
    meta: "Flat 11 A · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p23",
    category: "interior",
    segment: "residential",
    span: "md:col-span-8",
    image: "/projects/bhawani-8-dining.jpg",
    title: "Dining Room — Bhawani Enclave 8",
    meta: "Flat 8 · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p24",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/bhawani-8-kitchen.jpg",
    title: "Kitchen & Bar Rack — Bhawani Enclave 8",
    meta: "Flat 8 · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p25",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/bhawani-8-crockery.jpg",
    title: "Crockery Display Unit — Bhawani Enclave 8",
    meta: "Flat 8 · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p26",
    category: "interior",
    segment: "residential",
    span: "md:col-span-8",
    image: "/projects/bhawani-8-kids.jpg",
    title: "Kids' Room, Winter Theme — Bhawani Enclave 8",
    meta: "Flat 8 · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p27",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/bhawani-8-study.jpg",
    title: "Study Desk — Bhawani Enclave 8",
    meta: "Flat 8 · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p28",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/bhawani-8-breakfast.jpg",
    title: "Breakfast Counter — Bhawani Enclave 8",
    meta: "Flat 8 · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p29",
    category: "interior",
    segment: "residential",
    span: "md:col-span-8",
    image: "/projects/bhawani-8-living.jpg",
    title: "Living Room, Botanical Mural — Bhawani Enclave 8",
    meta: "Flat 8 · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p30",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/bhawani-8-mandir.jpg",
    title: "Mandir, Om Mural — Bhawani Enclave 8",
    meta: "Flat 8 · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p31",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/bhawani-8-mandir-2.jpg",
    title: "Mandir, Bells & Jaali Door — Bhawani Enclave 8",
    meta: "Flat 8 · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p32",
    category: "interior",
    segment: "residential",
    span: "md:col-span-8",
    image: "/projects/bhawani-8-buddha.jpg",
    title: "Living Room, Buddha Mural — Bhawani Enclave 8",
    meta: "Flat 8 · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p33",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/bhawani-8-tv-wall.jpg",
    title: "TV Wall, Backlit Panels — Bhawani Enclave 8",
    meta: "Flat 8 · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p34",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/bhawani-8-guest-bedroom.jpg",
    title: "Guest Bedroom, Botanical Walls — Bhawani Enclave 8",
    meta: "Flat 8 · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p35",
    category: "interior",
    segment: "residential",
    span: "md:col-span-8",
    image: "/projects/bhawani-8-master.jpg",
    title: "Master Bedroom & Wardrobe Wall — Bhawani Enclave 8",
    meta: "Flat 8 · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p36",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/bhawani-8-kitchen-3.jpg",
    title: "Kitchen, Glass-Front Cabinets — Bhawani Enclave 8",
    meta: "Flat 8 · Khagaul, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p37",
    category: "interior",
    segment: "commercial",
    span: "md:col-span-8",
    image: "/projects/banquet-stage.jpg",
    title: "Banquet Hall — Main Stage",
    meta: "Banquet Halls + 3rd Floor Rooms · Commercial",
    tag: "INTERIOR",
  },
  {
    id: "p38",
    category: "interior",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/banquet-tables.jpg",
    title: "Banquet Seating — Round Tables",
    meta: "Banquet Halls + 3rd Floor Rooms · Commercial",
    tag: "INTERIOR",
  },
  {
    id: "p39",
    category: "interior",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/banquet-lounge.jpg",
    title: "Guest Lounge — Banquet Hall",
    meta: "Banquet Halls + 3rd Floor Rooms · Commercial",
    tag: "INTERIOR",
  },
  {
    id: "p40",
    category: "interior",
    segment: "commercial",
    span: "md:col-span-8",
    image: "/projects/kanakarbagh-buffet.jpg",
    title: "Buffet Court & Buddha Feature — Kanakarbagh",
    meta: "Banquet Hall · Kanakarbagh, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p41",
    category: "interior",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/kanakarbagh-hall.jpg",
    title: "Floral Arch Columns — Kanakarbagh",
    meta: "Banquet Hall · Kanakarbagh, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p42",
    category: "interior",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/kanakarbagh-real.jpg",
    title: "Completed Hall, On-Site — Kanakarbagh",
    meta: "Banquet Hall · Kanakarbagh, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p43",
    category: "design",
    segment: "commercial",
    span: "md:col-span-8",
    image: "/projects/kanakarbagh-floor-plan.jpg",
    title: "Floor Plan — Kanakarbagh Banquet",
    meta: "Design Consultation · Kanakarbagh, Patna",
    tag: "DESIGN",
  },
  {
    id: "p44",
    category: "design",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/kanakarbagh-ceiling-plan.jpg",
    title: "Ceiling Plan — Kanakarbagh Banquet",
    meta: "Design Consultation · Kanakarbagh, Patna",
    tag: "DESIGN",
  },
  {
    id: "p45",
    category: "design",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/kanakarbagh-elevation.jpg",
    title: "Elevation Drawing — Kanakarbagh Banquet",
    meta: "Design Consultation · Kanakarbagh, Patna",
    tag: "DESIGN",
  },
  {
    id: "p46",
    category: "design",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/kanakarbagh-hvac.jpg",
    title: "HVAC Layout — Kanakarbagh Banquet",
    meta: "Design Consultation · Kanakarbagh, Patna",
    tag: "DESIGN",
  },
  {
    id: "p47",
    category: "design",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/kanakarbagh-rooms.jpg",
    title: "3rd Floor Rooms Plan — Kanakarbagh",
    meta: "Design Consultation · Kanakarbagh, Patna",
    tag: "DESIGN",
  },
  {
    id: "p48",
    category: "interior",
    segment: "residential",
    span: "md:col-span-8",
    image: "/projects/ajay-nilayam-kids-bedroom.jpg",
    title: "Kids' Bedroom, Twin Beds — Ajay Nilayam",
    meta: "4BHK · Flats 1+2 Merged, 4th Floor · Nageshwar Colony",
    tag: "INTERIOR",
  },
  {
    id: "p49",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/ajay-nilayam-study.jpg",
    title: "Kids' Study Room — Ajay Nilayam",
    meta: "4BHK · Flats 1+2 Merged, 4th Floor · Nageshwar Colony",
    tag: "INTERIOR",
  },
  {
    id: "p50",
    category: "design",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/ajay-nilayam-master-drawing.jpg",
    title: "Master Bedroom Working Drawing — Ajay Nilayam",
    meta: "Design Consultation · Nageshwar Colony, Patna",
    tag: "DESIGN",
  },
  {
    id: "p51",
    category: "design",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/ajay-nilayam-ceiling-plan.jpg",
    title: "False Ceiling Plan — Ajay Nilayam",
    meta: "Design Consultation · Nageshwar Colony, Patna",
    tag: "DESIGN",
  },
  {
    id: "p52",
    category: "design",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/ajay-nilayam-partition-wall.jpg",
    title: "Partition Wall Detail — Ajay Nilayam",
    meta: "Design Consultation · Nageshwar Colony, Patna",
    tag: "DESIGN",
  },
  {
    id: "p53",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/ajay-nilayam-master.jpg",
    title: "Master Bedroom, Glass Wardrobe — Ajay Nilayam",
    meta: "4BHK · Flats 1+2 Merged, 4th Floor · Nageshwar Colony",
    tag: "INTERIOR",
  },
  {
    id: "p54",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/ajay-nilayam-office.jpg",
    title: "Home Office — Ajay Nilayam",
    meta: "4BHK · Flats 1+2 Merged, 4th Floor · Nageshwar Colony",
    tag: "INTERIOR",
  },
  {
    id: "p55",
    category: "design",
    segment: "residential",
    span: "md:col-span-8",
    image: "/projects/ajay-nilayam-floor-plan.jpg",
    title: "Merged Floor Plan — Ajay Nilayam",
    meta: "Design Consultation · Nageshwar Colony, Patna",
    tag: "DESIGN",
  },
  {
    id: "p56",
    category: "design",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/ajay-nilayam-ceiling-layout.jpg",
    title: "False Ceiling Layout — Ajay Nilayam",
    meta: "Design Consultation · Nageshwar Colony, Patna",
    tag: "DESIGN",
  },
  {
    id: "p57",
    category: "design",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/ajay-nilayam-kitchen-drawing.jpg",
    title: "Kitchen Working Drawing — Ajay Nilayam",
    meta: "Design Consultation · Nageshwar Colony, Patna",
    tag: "DESIGN",
  },
  {
    id: "p58",
    category: "design",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/ajay-nilayam-final-set.jpg",
    title: "Complete Drawing Set — Ajay Nilayam",
    meta: "Design Consultation · Nageshwar Colony, Patna",
    tag: "DESIGN",
  },
  {
    id: "p59",
    category: "interior",
    segment: "commercial",
    span: "md:col-span-8",
    image: "/projects/eye-hospital-corridor.jpg",
    title: "Corridor & Waiting Lounge — Eye Hospital",
    meta: "Eye Hospital · Kanakarbagh, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p60",
    category: "interior",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/eye-hospital-pharmacy.jpg",
    title: "Pharmacy — Eye Hospital",
    meta: "Eye Hospital · Kanakarbagh, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p61",
    category: "interior",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/eye-hospital-planters.jpg",
    title: "Planter Divider — Eye Hospital",
    meta: "Eye Hospital · Kanakarbagh, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p62",
    category: "interior",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/eye-hospital-seating.jpg",
    title: "Seating Nook — Eye Hospital",
    meta: "Eye Hospital · Kanakarbagh, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p63",
    category: "interior",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/eye-hospital-reception.jpg",
    title: "Reception Concept — Eye Hospital",
    meta: "Eye Hospital · Kanakarbagh, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p64",
    category: "interior",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/eye-hospital-staircase.jpg",
    title: "Staircase, Timber Finish — Eye Hospital",
    meta: "Eye Hospital · Kanakarbagh, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p65",
    category: "interior",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/eye-hospital-staircase-2.jpg",
    title: "Staircase & Indoor Garden — Eye Hospital",
    meta: "Eye Hospital · Kanakarbagh, Patna",
    tag: "INTERIOR",
  },
  {
    id: "p66",
    category: "design",
    segment: "commercial",
    span: "md:col-span-8",
    image: "/projects/eye-hospital-ground-floor.jpg",
    title: "Ground Floor Plan — Eye Hospital",
    meta: "Design Consultation · Kanakarbagh, Patna",
    tag: "DESIGN",
  },
  {
    id: "p67",
    category: "design",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/eye-hospital-electrical.jpg",
    title: "Electrical Layout — Eye Hospital",
    meta: "Design Consultation · Kanakarbagh, Patna",
    tag: "DESIGN",
  },
  {
    id: "p68",
    category: "design",
    segment: "commercial",
    span: "md:col-span-4",
    image: "/projects/eye-hospital-g2-plan.jpg",
    title: "Ground Floor Plan G-2 — Eye Hospital",
    meta: "Design Consultation · Kanakarbagh, Patna",
    tag: "DESIGN",
  },
  {
    id: "p10",
    category: "interior",
    segment: "residential",
    span: "md:col-span-4",
    image: "/projects/basanti-flat-master-2.jpg",
    title: "Bedroom & CNC Jaali — Basanti Kunj",
    meta: "1st Floor, Flat 5 · Patna",
    tag: "INTERIOR",
  },
];

export const TIMELINE = [
  {
    year: "2014",
    title: "B.E. Civil Engineering",
    org: "Visvesvaraya Technological University, India",
    note: "Interned as Planning Scheduler & Site Engineer at Mantri Developers, Bangalore — first taste of a live site.",
  },
  {
    year: "2014–15",
    title: "Design Engineer → Project Coordinator",
    org: "Invicus Engineering Pvt. Ltd., Bangalore",
    note: "Eighteen months across design and coordination desks.",
  },
  {
    year: "2016",
    title: "M.Eng — Construction Engineering & Management",
    org: "Stevens Institute of Technology, New Jersey, USA",
    note: "OSHA certified · USGBC Green Associate.",
  },
  {
    year: "2017",
    title: "Project & Cost Engineer",
    org: "Infinity Contracting Services, USA",
    note: "CCM certified · Oracle Primavera P6 certified.",
  },
  {
    year: "2017–19",
    title: "Assistant Project Manager — Contracts & Commercial",
    org: "Ray Builders, United States",
    note: "Ran contract administration, change orders and claims on US projects.",
  },
  {
    year: "2020",
    title: "Design Consultant — Contracts & Technical Documentation Lead",
    org: "Edge Construction Consultant, Patna",
    note: "Returned home to Bihar. Six months later, the leap.",
  },
  {
    year: "OCT 2020",
    title: "Co-Founder & Head — Civil Projects (EPC/PMC)",
    org: "Subhankara Design & Construction Pvt. Ltd., Patna",
    note: "First-generation businessman. No legacy, no safety net — just craft.",
    highlight: true,
  },
];

export const CHALLENGES = [
  {
    index: "01",
    title: "Trust, built from zero",
    text: "No family name on the door meant every client was won on drawings, estimates and delivered work — not referrals from a legacy network.",
  },
  {
    index: "02",
    title: "Capital on a leash",
    text: "First-generation means self-funded. Every project had to cash-flow the next, so discipline in contracts and billing became our culture.",
  },
  {
    index: "03",
    title: "Competing with established players",
    text: "We answered with international documentation standards — Primavera P6 schedules, SOR-accurate estimates and transparent BOQs.",
  },
  {
    index: "04",
    title: "Learning business while doing business",
    text: "GST, compliance, vendor credit, team building — learned on live projects, with clients watching. The margin for error was zero.",
  },
];

const FILMS = [
  { src: "/videos/boring-road-completed", title: "Boring Road — Completed" },
  { src: "/videos/basanti-kunj-boring-road", title: "Basanti Kunj, Boring Road" },
  { src: "/videos/aiims-patna", title: "AIIMS Patna" },
  { src: "/videos/allahabad-bank-colony", title: "Allahabad Bank Colony" },
  { src: "/videos/apartment-shopping-complex-danapur", title: "Apartment & Shopping Complex, Danapur" },
  { src: "/videos/friends-colony", title: "Friends Colony" },
  { src: "/videos/banquet-8ft-ceiling", title: "8ft Ceiling Banquet — A Challenge I Enjoyed" },
  { src: "/videos/site-walkthrough", title: "Site Walkthrough" },
  { src: "/videos/interior-walkthrough", title: "Interior Design Walkthrough" },
  { src: "/videos/bedroom-interior-walkthrough", title: "Bedroom Interior Walkthrough" },
  { src: "/videos/office-design-rps-more", title: "Office Design — RPS More, Patna" },
  { src: "/videos/office-design-kaliket-nagar", title: "Office Design — Kaliket Nagar, Patna" },
  { src: "/videos/3d-interior-concepts", title: "3D Interior Design Concepts" },
  { src: "/videos/basant-apartment-102", title: "Basant Apartment 102 — Interior" },
  { src: "/videos/floorplan-option-1-roaming", title: "Floorplan Option 1 — 3D Room Tour" },
  { src: "/videos/living-room-3d-concept", title: "Living Room — 3D Concept" },
  { src: "/videos/restaurant-3d-walkthrough", title: "Restaurant Interior — 3D Walkthrough" },
  { src: "/videos/restaurant-entrance-3d-tour", title: "Restaurant Entrance — 3D Tour" },
  { src: "/videos/floorplan-lighting-animation", title: "Floorplan Option 1 — Lighting Animation" },
  { src: "/videos/us-commercial-interior", title: "Commercial Interior — US Project" },
  { src: "/videos/us-site-steel-framing", title: "Steel Framing — US Site" },
  { src: "/videos/us-site-mep-framing", title: "MEP & Framing — US Site" },
  { src: "/videos/us-site-setup", title: "Site Setup — US Project" },
  { src: "/videos/us-site-stairwell", title: "Concrete Stairwell — US Site" },
  { src: "/videos/raja-bazar-3d-in-progress", title: "Raja Bazar, Patna — 3D Project in Progress" },
  { src: "/videos/ajay-nilayam-walkthrough", title: "Ajay Nilayam — In-Progress Walkthrough" },
  { src: "/videos/ajay-nilayam-details", title: "Ajay Nilayam — In-Progress Details" },
  { src: "/videos/kanakarbagh-banquet-completed", title: "Kanakarbagh Banquet Hall — Completed" },
];

export const PROJECT_VIDEOS = Array.from({ length: Math.max(25, FILMS.length) }, (_, i) => {
  const index = String(i + 1).padStart(2, "0");
  const film = FILMS[i];
  return {
    id: `video-${index}`,
    index,
    src: film ? film.src : null,
    title: film ? film.title : `Project Film ${index}`,
  };
});

export const FOUNDER_PHOTOS = [
  { id: "founder-photo-1", src: "/founder/sarthak-6.jpg", alt: "Sarthak Singh — Co-Founder, Subhankara" },
  { id: "founder-photo-2", src: "/founder/sarthak-2.jpg", alt: "Graduation — Stevens Institute of Technology, USA" },
  { id: "founder-photo-3", src: "/founder/sarthak-3.jpg", alt: "On site — Ray Builders, USA" },
  { id: "founder-photo-4", src: "/founder/sarthak-1.jpg", alt: "Sarthak Singh — portrait" },
  { id: "founder-photo-5", src: "/founder/sarthak-4.jpg", alt: "Sarthak Singh — United States" },
  { id: "founder-photo-6", src: "/founder/sarthak-5.jpg", alt: "Building Futures — Subhankara" },
];

export const FOUNDER = {
  name: "Sarthak Singh",
  role: "Co-Founder & Head — Civil Projects (EPC/PMC)",
  quote: "I love creating things rather than buying.",
  certs: ["OSHA", "USGBC Green Associate", "CCM", "Oracle Primavera P6"],
};
